import React from "react";
import { Divider, Checkbox, Typography, Spin, Button } from "antd";
import { MessageOutlined } from "@ant-design/icons";
import PriceFilter from "./PriceFilter"; // Ajusta si cambiaste la carpeta
import "../../../styles/FiltersPanel.css"; // Importación local

const { Text } = Typography;

export default function FiltersPanel({
  priceRange,
  onPriceChange,
  selectedBrands,
  onBrandsChange,
  loadingBrands,
  brandsOptions,
  onOpenMessages,
  onApplyFilters,
  onClearFilters,
}) {
  return (
    <div className="filters-panel-container">
      {/* Bloque superior */}
      <div className="filters-panel-top">
        <div className="mpl-filter-section">
          <PriceFilter value={priceRange} onChange={onPriceChange} />
        </div>
        <Divider />
        <div className="mpl-filter-section">
          <Text strong>Marcas:</Text>
          {loadingBrands ? (
            <div className="brands-spinner">
              <Spin />
            </div>
          ) : (
            <Checkbox.Group
              options={brandsOptions}
              value={selectedBrands}
              onChange={onBrandsChange}
              className="mpl-brands-checkbox-group"
            />
          )}
        </div>
        <Divider />
        <div className="mpl-filter-buttons">
          <Button type="primary" block onClick={onApplyFilters}>
            Aplicar filtros
          </Button>
          <Button type="default" block onClick={onClearFilters}>
            Limpiar filtros
          </Button>
        </div>
      </div>

      <Divider className="filters-divider" />

      <div className="filters-panel-bottom">
        <Text
          className="mpl-messages-link"
          onClick={onOpenMessages}
          style={{
            display: "flex",
            alignItems: "center",
            cursor: "pointer",
            color: "#4c007d",
          }}
        >
          <MessageOutlined style={{ marginRight: 8 }} /> Mis mensajes
        </Text>
      </div>
    </div>
  );
}
